var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnnouncement = function SvgAnnouncement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m2.335 10.667 1.312 5.249c.037.147.055.22.077.285.213.63.78 1.073 1.443 1.127.068.005.144.005.296.005.19 0 .286 0 .366-.007a1.67 1.67 0 0 0 1.498-1.498c.008-.08.008-.176.008-.367V3.583m7.083 6.667a2.917 2.917 0 0 0 0-5.833m-6.875-.834H4.418a3.75 3.75 0 1 0 0 7.5h3.125c1.472 0 3.273.79 4.662 1.547.81.441 1.216.662 1.48.63a.79.79 0 0 0 .577-.342c.156-.218.156-.653.156-1.523V3.272c0-.87 0-1.305-.156-1.523a.79.79 0 0 0-.576-.342c-.265-.033-.67.188-1.481.63-1.39.757-3.19 1.546-4.662 1.546"
  })));
};
export default SvgAnnouncement;